import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import Styles from "../../../../../Slices/Mof/Styles.json";

import axios from 'axios'
import ApiSetting from '../../../../../../Settings/ApiSettings.json'
import Cookies from "universal-cookie";
import swal from "sweetalert";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";


function SignatureOfTaxPayer({getCurrentReportDataAfterUpdate,object,Access,advanceSearch,section_id,stage_transaction_type_id}) {
   const [agencyNo,setAgencyNo]=useState(object?.agency_no)
   // Normalize potentially string dates to Date | null
   const normalizeDate = (d) => {
     if (!d) return null;
     if (d instanceof Date) return isNaN(d.getTime()) ? null : d;
     if (typeof d === 'string') {
       const iso = d.match(/^(\d{4})-(\d{2})-(\d{2})$/);
       if (iso) {
         const y = Number(iso[1]), m = Number(iso[2]) - 1, day = Number(iso[3]);
         const date = new Date(y, m, day);
         return isNaN(date.getTime()) ? null : date;
       }
       const slash = d.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
       if (slash) {
         const day = Number(slash[1]), m = Number(slash[2]) - 1, y = Number(slash[3]);
         const date = new Date(y, m, day);
         return isNaN(date.getTime()) ? null : date;
       }
       const parsed = new Date(d);
       return isNaN(parsed.getTime()) ? null : parsed;
     }
     return null;
   }
   const [agencyNoDate,setAgencyNoDate]=useState(normalizeDate(object?.agency_no_date))
   const [issuer,setIssuer]=useState(object?.issuer);
   const [loading,setLoading]=useState(false)

   //============format date to format yyyy-mm-dd============
   const formatDate = (date) => {
    let y = date.getFullYear();

    let m = date.getMonth() + 1;
    if (m < 10) m = "0" + m;

    let d = date.getDate();
    if (d < 10) d = "0" + d;

    return y + "-" + m + "-" + d;
   };
   const updateData=async()=>{
    let data=null;
    setLoading(true);
    try{
        data=await axios({
           method: 'put',
           url:ApiSetting.apiUrl+'/income_tax_report/'+object?.id,
           data:{
            section_name:'7',
            agency_no:agencyNo,
            agency_no_date: agencyNoDate ? formatDate(agencyNoDate) : null,
            issuer:issuer,
            user_id:cookies.get('user_id'),
            role_id:cookies.get('role_id')+1,
            section_id:section_id,
            stage_transaction_type_id:stage_transaction_type_id
           },
           headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "X-localization": language,
           }
        })
        if(data){
            if(data?.data?.status==200){
                swal("تم التحديث!", `${data?.data?.message}`, "success");
                setAgencyNo(data?.data?.data?.agency_no);
                setAgencyNoDate(normalizeDate(data?.data?.data?.agency_no_date));
                setIssuer(data?.data?.data?.issuer);
                advanceSearch()
                getCurrentReportDataAfterUpdate()

            }else{
                console.log(data?.data?.message);
                swal("فشل التحديث!", `${data?.data?.message}`, "warning");

            }
        }
    setLoading(false);

    }catch(err){
        swal("فشل التحديث!", `${err?.message}`, "error");
        setLoading(false);

    }
    
   }
   const checkAccessPrivileges =()=>{
    let check=true;
    Access?.map((data)=>{
        if(data==1){
            check=true;
        }else if(data==2||data==3||data==4){
            check=false
        }
    })
    return check;
   }

   const checkAccessPrivilegesCanEdit=()=>{
    let check=false;
    Access?.map((data)=>{
        if(data==3){
            check=true;
         }
    })
    return check;
   }
   const checkAccessPrivilegesCanAdd=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==2){
                check=true;
            }
        })
        return check;
   }


    return (
        <>
            {/*###==> signature of taxpayer and speculatie here ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                {" معلومات الوكالة"}
            </h4>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",

                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        width: "23%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            label="رقم الوكالة"
                            variant="outlined"
                            value={agencyNo}
                            onChange={(e) => {
                                setAgencyNo(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.agencyNo) {
                            return err.agencyNo;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "23%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="تاريخ  الوكالة"
                                inputFormat="dd/MM/yyyy"
                                InputProps={{
                                    readOnly: checkAccessPrivileges(),
                                }}
                                disabled={checkAccessPrivileges()}
                                value={normalizeDate(agencyNoDate)}
                                onChange={(date) => {
                                    const val = (date instanceof Date && !isNaN(date.getTime())) ? date : null;
                                    setAgencyNoDate(val);
                                }}
                                renderInput={(params) => <TextField InputProps={{
                                    readOnly: true,
                                }} {...params} />}
                            />
                        </LocalizationProvider>
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.agencyNoDate) {
                            return err.agencyNoDate;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width: "23%",
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label=" جهة الاصدار"
                            variant="outlined"
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            value={issuer}
                            onChange={(e) => {
                                setIssuer(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.issuer) {
                            return err.issuer;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

            </div>
            {
                checkAccessPrivilegesCanAdd()||checkAccessPrivilegesCanEdit()?
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                    <Button variant="contained" style={{backgroundColor:"#5f7b8a",paddingLeft:30,paddingRight:30}}
                    onClick={()=>{
                        updateData();
                    }}
                    >
                        {!loading ? (
                        "تحديث"
                    ) : (
                        <div class="spinner-border " role="status">
                        <span class="visually-hidden">Loading...</span>
                        </div>
                    )}
                    </Button>
                </div>:null
           }
        </>
    )
}

export default SignatureOfTaxPayer